module.exports = __webpack_public_path__ + "pnskfsquadron/img/tw-slider-1.jpg?ee7a3a3e";